<template>
	<div class="content-class">
		<v-tabs v-model="active" color="black" dark slider-color="primary">
			<v-tab :key="'defaultParmaters'" ripple>Paramamètre par défaut</v-tab>
			<v-tab :key="'Logs'" ripple>Logs</v-tab>

			<v-tab-item :key="'defaultParmaters'">
				<default-parameters-form v-model="document" />

				<v-btn :disabled="loading" color="error" @click="deleteUser()">
					<v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
					Supprimer
				</v-btn>
			</v-tab-item>

			<v-tab-item :key="'Logs'">
				<log-list
					:url="'logs?filter=references.reference:$eq:defaultparmaters;references.referenceId:$eq:' + $route.params.id"
				>
				</log-list>
			</v-tab-item>
		</v-tabs>
	</div>
</template>
<script>
import DefaultParametersForm from '../../components/defaultParameters/defaultParameters.form'
import LogList from '../../components/logs/log.list.vue'

import { ERROR, SUCCESS } from '../../variables'

export default {
	components: { DefaultParametersForm, LogList },
	data() {
		return {
			loading: false,
			active: null,
			document: null,
		}
	},
	methods: {
		deleteUser() {
			this.axios
				.delete('default-parameters/' + this.$route.params.id)
				.then((response) => {
					this.$router.push({ name: 'DefaultParametersList' })
					this.$store.dispatch(SUCCESS, 'Paramètre par défaut supprimé')
				})
				.catch((err) => {
					this.$store.dispatch(ERROR, err)
				})
		},
	},
	mounted() {
		this.axios
			.get('default-parameters/' + this.$route.params.id)
			.then((response) => {
				this.document = response.data
			})
			.catch((err) => {
				this.$store.dispatch(ERROR, err)
			})
	},
}
</script>
<style lang="scss">
.content-class {
	width: 100%;
	height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/defaultParameters/defaultParameters.detail.vue